// Café da Fábrica — seletor de quantidade dentro do card de produto.
// Fica num asset global (e não num <script> dentro do card) porque seções
// carregadas por AJAX, como "produtos recomendados", são injetadas via
// innerHTML — e nesse caso scripts inline nunca executam.
(function () {
  if (window.__mcVsel) return;
  window.__mcVsel = true;

  document.addEventListener('click', function (e) {
    const chip = e.target.closest('.mc-vsel__chip');
    if (!chip) return;
    e.preventDefault();

    const card = chip.closest('product-card') || chip.closest('.product-grid__card');
    if (!card) return;

    card.querySelectorAll('.mc-vsel__chip').forEach(function (b) {
      const on = b === chip;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    const price = card.querySelector('.price');
    if (price) price.textContent = chip.dataset.total;

    const unit = card.querySelector('.mc-card-unit b');
    if (unit) unit.textContent = chip.dataset.unit;

    const input = card.querySelector('input[name="id"]');
    if (input) input.value = chip.dataset.vid;

    const buy = card.querySelector('[data-mc-buy]');
    if (buy) {
      const base = (buy.getAttribute('href') || '').split('?')[0];
      buy.setAttribute('href', base + '?variant=' + chip.dataset.vid);
    }
  });
})();
